import UrlGetsStore from '@/stores/compiled/store-compiled-url-gets';
import UrlPostsStore from '@/stores/compiled/store-compiled-url-posts';

export async function GetStore(
  method: string,
  url: string,
): Promise<{
  has: boolean;
  status: number;
  statusText: string;
  headers: any;
  data: any;
}> {
  let checkStoreBuilded = true;

  try {
    if (process && !process.client) {
      if (process?.env?.BUILD_TYPE === 'server') {
        if (process?.env?.BUILD_COMPILE_STORE === 'yes') {
          checkStoreBuilded = false;
        }
      }
    }
  } catch (ex) {
    checkStoreBuilded = true;
  }

  if (checkStoreBuilded) {
    let storeData: any = false;

    switch (method) {
      case 'GET':
        storeData = await UrlGetsStore(url);
        break;

      case 'POST':
        storeData = await UrlPostsStore(url);
        break;
    }

    if (storeData === false || storeData === true) {
      return {
        has: false,
        status: 404,
        statusText: 'Not found',
        headers: {
          FromBuildCheck: true,
        },
        data: null,
      };
    }
    if (storeData) {
      storeData.headers = storeData.headers || {};
      if (storeData.headers === 'd') {
        storeData.headers = {
          'cache-control': 'max-age=0, no-cache, must-revalidate',
          'content-type': 'application/json',
        };
      }
      if (typeof storeData.headers !== 'object') {
        storeData.headers = {};
      }
      storeData.headers.FromBuildCheck = true;

      return {
        has: true,
        status: 200,
        statusText: 'Ok',
        data: storeData.data,
        headers: storeData.headers,
      };
    }
  }

  return {
    has: false,
    status: 404,
    statusText: 'Not found',
    headers: {
      FromBuildCheck: true,
    },
    data: null,
  };
}
